import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Swallow the benign "ResizeObserver loop" noise so the CRA/webpack dev overlay
// doesn't hijack the screen after Radix dialog/select transitions (dev/preview only).
const RO_MSG = /ResizeObserver loop/;
const hideDevOverlay = () => {
  ["webpack-dev-server-client-overlay", "webpack-dev-server-client-overlay-div"].forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.style.display = "none";
  });
};
window.addEventListener(
  "error",
  (e) => {
    if (e.message && RO_MSG.test(e.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
      hideDevOverlay();
    }
  },
  true,
);


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
